<template>
  <el-container id="tab">
    <el-aside :width="isCollapse ? '20px' : '230px'">
      <el-card v-show="!isCollapse" class="box-card">
        <div slot="header">
          <span>查询条件</span>
          <el-button style="float: right; padding: 3px 0" icon="el-icon-d-arrow-left" type="text" @click="isCollapse = !isCollapse"></el-button>
        </div>
        <el-form ref="queryFormRef" :model="queryForm" :rules="queryFormRules" size="small">
          <el-scrollbar>
            <el-form-item label="客户" prop="customer.selected">
              <select-multiple class="query_form_item" :select-data="queryForm.customer" :change="() => { getBalanceAmt('customer') }" :isClear="false" isTable :column-list="selectMultipleTableColumnListCommon.customer"></select-multiple>
            </el-form-item>
            <el-form-item label="所属公司" prop="subCompanyID.selected">
              <select-multiple style="width: 100%;" :select-data="queryForm.subCompanyID" :isClear="false" :change="() => { getBalanceAmt('subCompanyID') }"></select-multiple>
            </el-form-item>
            <el-form-item label="品牌" prop="brand.selected">
              <select-multiple class="query_form_item" ref="brand" :select-data="queryForm.brand" :change="() => { getBalanceAmt('brand') }" :isClear="false"></select-multiple>
            </el-form-item>
            <el-form-item v-loading="balanceAmtLoading">
              <p class="amt-info">
                <span>欠款：{{ balanceAmt.arrearAmt || 0 }}元</span>
                <span>预收：{{ balanceAmt.prePayAmt || 0 }}元</span>
              </p>
            </el-form-item>
            <el-form-item style="text-align: center;">
              <el-button type="primary" @click="selectDetail" style="width: 128px;">选择欠款明细</el-button>
            </el-form-item>
            <el-form-item style="text-align: center;">
              <el-button type="primary" @click="selectDetailAll">加载全部欠款明细</el-button>
            </el-form-item>
            <!-- <el-form-item label="业务员" prop="salesman.selected">
              <select-multiple class="query_form_item" ref="salesman" :select-data="queryForm.salesman" :change="() => { multipleChange('salesman') }"></select-multiple>
            </el-form-item>
            <el-form-item label="审核人" prop="entryUser.selected">
              <select-multiple class="query_form_item" ref="entryUser" :select-data="queryForm.entryUser" :change="() => { multipleChange('entryUser') }"></select-multiple>
            </el-form-item>
            <el-form-item label="备注" prop="remark.selected">
              <el-input v-model="queryForm.remark.selected" ref="remark" type="textarea" :autosize="{ minRows: 2 }" clearable placeholder="请输入备注"></el-input>
            </el-form-item> -->
          </el-scrollbar>
        </el-form>
      </el-card>
      <div class="is-collapse" v-show="isCollapse" @click="isCollapse = !isCollapse">
        <span style="text-align: center;">查询</span>
        <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
        <span style="text-align: center;">条件</span>
      </div>
    </el-aside>
    <el-main>
      <el-card class="box-card">
        <div slot="header">
          <span>待收款单据</span>
        </div>
        <!-- <el-card class="box-card-query" shadow="never">
          <el-form :inline="true" size="small">
            <el-form-item>
              <el-button type="primary" @click="selectDetail">选择欠款明细</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="selectDetailAll">加载全部欠款明细</el-button>
            </el-form-item>
          </el-form>
        </el-card> -->
        <div class="table" v-loading="tableLoading">
          <!--  show-summary -->
          <el-table ref="table" :data="tableData" style="width: 100%" border stripe height="100%" max-height="100%" show-summary :summary-method="tableSummaries" @filter-change="filterMethod" @row-dblclick="billDetailOpen">
            <el-table-column type="index" width="55" align="center"></el-table-column>
            <el-table-column prop="entryDate" label="录单/审核日期" width="130" align="center" column-key="billDate" :filters="sortfilters" :filter-multiple="false" filter-placement="bottom">
              <template slot-scope="{ row }">
                <p class="cell-p">{{ row.entryDate }}</p>
                <p class="border cell-p" v-if="row.recordDate">{{ row.recordDate }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="billNo" label="单号/订单号" width="176" align="center">
              <template slot-scope="{ row }">
                <p class="cell-p">{{ row.billNo }}</p>
                <p class="border cell-p" v-if="row.orderBillNo">{{ row.orderBillNo }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="customerName" label="客户" width="140" align="center"></el-table-column>
            <el-table-column prop="salesmanName" label="业务员/审核人" width="140" align="center">
              <template slot-scope="{ row }">
                <p class="cell-p">{{ row.salesmanName }}</p>
                <p class="border cell-p" v-if="row.recordedUserName">{{ row.recordedUserName }}</p>
              </template>
            </el-table-column>
             <el-table-column prop="arrearAmt" label="应收账款" width="80" align="center"></el-table-column>
             <el-table-column prop="settlementAmt" label="已结算" width="80" align="center">
                <template slot-scope="{ row }">
                  <p>{{ Number(row.arrearAmt || 0) - Number(row.billArrearBalance || 0) }}</p>
                </template>
             </el-table-column>
             <el-table-column prop="billArrearBalance" label="待结算" width="80" align="center"></el-table-column>
             <el-table-column prop="strikAmt" label="本次结算" width="100" align="center">
               <template slot-scope="{ row }">
                <el-input-number v-model.number="row.strikAmt" size="small" v-focus :controls="false" style="width: 100%;" :precision="2" :min="row.billArrearBalance > 0 ? 0 : Number(row.billArrearBalance)" :max="row.billArrearBalance > 0 ? Number(row.billArrearBalance) : 0" @blur="strikAmtIsShow(row, false)"></el-input-number>
                <!-- <el-input-number v-if="row.strikAmtIsShow" v-model.number="row.strikAmt" size="small" v-focus :controls="false" style="width: 100%;" :precision="2" :min="row.billArrearBalance > 0 ? 0 : Number(row.billArrearBalance)" :max="row.billArrearBalance > 0 ? Number(row.billArrearBalance) : 0" @blur="strikAmtIsShow(row, false)"></el-input-number> -->
                <!-- <div v-else @click="strikAmtIsShow(row, true)">{{ Number(row.strikAmt || 0) }}</div> -->
              </template>
             </el-table-column>
             <el-table-column prop="warehouseName" label="操作" width="40" align="center">
               <template slot-scope="scope">
                  <el-button icon="el-icon-delete" type="text" @click="deleteRow(scope)"></el-button>
                  <!-- <el-button icon="el-icon-view" type="text" @click="deleteRow(scope)"></el-button> -->
               </template>
             </el-table-column>
          </el-table>
        </div>
      </el-card>
    </el-main>
    <el-aside width="230px">
      <el-card class="box-card">
        <div slot="header">
          <span>收款信息</span>
        </div>
        <el-form class="calculation-form" ref="calculationFormRef" :model="queryForm" size="small">
          <el-scrollbar>
            <el-form-item>
              <span>本次结算金额合计：{{ totalAmt }}元</span>
            </el-form-item>
            <el-form-item label="折扣" prop="discountAmt.selected">
              <el-input-number v-model="queryForm.discountAmt.selected" style="width: 100%;" :precision="2" :min="totalAmt > 0 ? 0 : totalAmt" :max="totalAmt > 0 ? totalAmt : 0" @change="numberChange($event, 'discountAmt')"></el-input-number>
            </el-form-item>
            <el-form-item label="实收" prop="payableAmt.selected">
              <el-input-number v-model="queryForm.payableAmt.selected" style="width: 100%;" :precision="2" :min="totalAmt > 0 ? 0 : totalAmt" :max="totalAmt > 0 ? totalAmt : 0" @change="numberChange($event, 'payableAmt')"></el-input-number>
            </el-form-item>
            <el-form-item label="现金" prop="cashAmt.selected" v-if="$store.state.power.isMoreCollection == 'Y'">
              <el-input-number v-model="queryForm.cashAmt.selected" style="width: 100%;" :precision="2" :min="queryForm.payableAmt.selected > 0 ? 0 : queryForm.payableAmt.selected" :max="queryForm.payableAmt.selected > 0 ? queryForm.payableAmt.selected : 0" @change="numberChange($event, 'cashAmt')"></el-input-number>
            </el-form-item>
            <el-form-item label="支付方式" prop="cardAmt.selected" v-if="$store.state.power.isMoreCollection == 'Y'">
              <div class="input-with-select el-input el-input-group el-input-group--append el-input-group--prepend">
                <div class="el-input-group__prepend">
                  <select-multiple ref="account" class="select-multiple payType" :select-data="queryForm.account" :isClear="false"></select-multiple>
                </div>
                <el-input-number style="width: 100%;" class="input_number" controls-position="right" v-model="queryForm.cardAmt.selected" :precision="2" :min="queryForm.payableAmt.selected > 0 ? 0 : queryForm.payableAmt.selected" :max="queryForm.payableAmt.selected > 0 ? queryForm.payableAmt.selected : 0" @change="numberChange($event, 'cardAmt')"></el-input-number>
              </div>
            </el-form-item>
            <el-form-item label="支付方式" prop="cardAmt.selected" v-else>
              <select-multiple ref="account" class="select-multiple" :select-data="queryForm.account" :isClear="false"></select-multiple>
            </el-form-item>
            <el-form :rules="submitFromRules" ref="calculationSubmitFormRef" :model="submitFrom" size="small">
              <el-form-item label="业务员" prop="salesman.selected">
                <select-multiple class="query_form_item" :select-data="submitFrom.salesman"></select-multiple>
              </el-form-item>
              <el-form-item label="备注" prop="remark.selected">
                <el-input v-model="submitFrom.remark.selected" type="textarea" :autosize="{ minRows: 2 }"  placeholder="请输入备注"></el-input>
              </el-form-item>
              <el-form-item>
                <el-dropdown split-button type="primary" @click="onSubmit" @command="onSubmit">
                  提交
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="A">提交并打印</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-form-item>
            </el-form>
          </el-scrollbar>
        </el-form>
      </el-card>
    </el-aside>
    <el-dialog title="选择欠款明细" width="86%" :visible.sync="dialogTableVisible" custom-class="dialogTable" :close-on-click-modal="false" destroy-on-close @close="dialogClose" @open="dialogOpen">
      <el-card class="box-card-query" shadow="never">
        <el-form :inline="true" size="small">
          <el-form-item>
            <div class="date-box" style="display: flex;">
                <el-select style="width: 100px !important;flex: 0 0 auto;" v-model="queryForm.dateType.selected" placeholder="请选择">
                    <el-option key="A" label="单据日期" value="A"></el-option>
                    <el-option key="B" label="制单日期" value="B"></el-option>
                    <el-option key="C" label="审核日期" value="C"></el-option>
                </el-select>
                <date-picker v-model="queryForm.billDate.selected" type="daterange"
                    align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                </date-picker>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="selectDetail">查询</el-button>
            <el-button type="warning" @click="printTable">打印</el-button>
          </el-form-item>
          <el-form-item style="float: right;">
            <el-button type="success" @click="onSelect">确定</el-button>
          </el-form-item>
          <el-form-item style="float: right; color: #F56C6C;">
            <span>选中：</span>
            <span style="margin-right: 6px;">{{ selection.length }}条,</span>
            <span>合计金额：</span>
            <span>{{ selection.amt }}元</span>
          </el-form-item>
        </el-form>
      </el-card>
      <div class="table" v-loading="dialogTableLoading">
        <el-table ref="dialogTable" :data="dialogTableData" style="width: 100%" border stripe height="100%" max-height="100%" row-key="billNo" @selection-change="handleSelectionChange" show-summary :summary-method="dialogTableSummaries" @filter-change="dialogFilterMethod">
          <el-table-column type="selection" width="55" align="center" reserve-selection></el-table-column>
          <el-table-column type="index" width="55" align="center"></el-table-column>
          <el-table-column prop="entryDate" label="录单/审核日期" width="130" align="center" column-key="billDate" :filters="sortfilters" :filter-multiple="false" filter-placement="bottom">
              <template slot-scope="{ row }">
                <p class="cell-p">{{ row.entryDate }}</p>
                <p class="border cell-p" v-if="row.recordDate">{{ row.recordDate }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="billNo" label="单号/订单号" width="176" align="center">
              <template slot="header">
                <el-popover placement="bottom" trigger="click" ref="popover_billNo" @show="popoverShow('billNo')">
                  <div class="query_btn_group">
                    <div class="el-input el-input--suffix billNo_input">
                      <input type="text" v-model="queryForm.billNo.selected" autocomplete="off" placeholder="输入单号搜索" class="el-input__inner">
                      <!-- <span class="el-input__suffix" @click="billNoInputClear">
                        <span class="el-input__suffix-inner">
                          <i class="el-input__icon el-icon-circle-close el-input__clear"></i>
                        </span>
                      </span> -->
                    </div>
                    <!-- <input ref="billNoInput" v-model="queryForm.billNo.selected" placeholder="输入单号搜索" clearable> -->
                    <el-button type="text" @click="tableFilter('billNo', 'billNo')">筛选</el-button>
                  </div>
                  <div slot="reference" :class="['reference', queryForm.billNo.isFilter ? 'highlight' : '' ]"><label>单号/订单号</label><i class='el-icon-arrow-down'></i></div>
                </el-popover>
              </template>
              <template slot-scope="{ row }">
                <p class="cell-p">{{ row.billNo }}</p>
                <p class="border cell-p" v-if="row.orderBillNo">{{ row.orderBillNo }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="billDate" label="单据日期" width="100" align="center"></el-table-column>
            <el-table-column prop="customerName" label="客户" width="100" align="center"></el-table-column>
            <el-table-column prop="salesmanName" label="业务员/审核人" width="110" align="center">
              <template slot="header">
                <el-popover placement="bottom" trigger="click" ref="popover_salesman" @show="popoverShow('salesman')">
                  <div class="query_btn_group">
                    <select-multiple class="query_form_item" ref="salesman" :select-data="queryForm.salesman"></select-multiple>
                    <el-button type="text" @click="tableFilter('salesman', 'salesman')">筛选</el-button>
                  </div>
                  <div class="query_btn_group">
                    <select-multiple class="query_form_item" ref="entryUser" :select-data="queryForm.entryUser"></select-multiple>
                    <el-button type="text" @click="tableFilter('salesman', 'entryUser')">筛选</el-button>
                  </div>
                  <div slot="reference" :class="['reference', Boolean(queryForm.salesman.isFilter || queryForm.entryUser.isFilter) ? 'highlight' : '' ]"><label>业务员/审核人</label><i class='el-icon-arrow-down'></i></div>
                </el-popover>
              </template>
              <template slot-scope="{ row }">
                <p class="cell-p">{{ row.salesmanName }}</p>
                <p class="border cell-p" v-if="row.recordedUserName">{{ row.recordedUserName }}</p>
              </template>
            </el-table-column>
             <el-table-column prop="arrearAmt" label="应收账款" width="100" align="center"></el-table-column>
             <el-table-column prop="settledAmt" label="已结算" width="100" align="center">
               <template slot-scope="{ row }">
                <p>{{ Number(row.arrearAmt || 0) - Number(row.billArrearBalance || 0) }}</p>
              </template>
             </el-table-column>
             <el-table-column prop="billArrearBalance" label="待结算" width="100" align="center"></el-table-column>
            <el-table-column prop="remark" label="备注" width="100" align="center"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog width="80%" title="" class="bill-detail-dialog" :visible.sync="billDetailVisible" append-to-body @close="billDetailClose">
      <bill-detail ref="billDetailDialog" :visible.sync="billDetailVisible"></bill-detail>
    </el-dialog>
  </el-container>
</template>

<script>
import datePicker from '@/components/common/datePicker.vue'
import billDetail from '@/components/salPayBalance/billDetail.vue'
import { pickerOptions, toRawType, getResultArray, toFixedRe } from '@/assets/js/common.js'
import { g_getKeyByValue, g_getValueByKey, printSalOrder } from '@/assets/js/printByPage.js'
export default {
  name: "CustomerArrearPerOrder",
  props: {
    customerID: String,
    customerName: String,
    financialBrandID: String,
    financialBrandName: String
  },
  components: {
    datePicker,
    billDetail
  },
  mixins: [selectMultipleTableColumnListCommonMixins],
  data() {
    return {
      isCollapse: false,
      queryForm: {
        customer: { submitName: 'customer', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择客户', request: { url: '/Account/customerDefine/getCustomerListForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
        subCompanyID: { submitName: 'subCompanyID', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], label: 'label', value: 'value', placeholder: '请选择所属公司', request: { url: '/Account/customerDefineVue/selectChainStoresList.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
        salesman: { submitName: 'salesmanID', selected: {}, isFilter: false, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择业务员', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: ''}},
        entryUser: { submitName: 'recordUserID', selected: {}, isFilter: false, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择审核人', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: ''}},
        remark: { submitName: 'remark', selected: '' },
        discountAmt: { submitName: 'discountAmt', selected: 0 },
        payableAmt: { submitName: 'payAmt', selected: 0 },
        cashAmt: { submitName: 'cashsPayAmt', selected: 0 },
        cardAmt: { submitName: 'othersPayAmt', selected: 0 },
        account: { submitName: 'account', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: false, isRemote: false, isPagination: false, isReSearch: false, isDisabled: false, isClear: false, list: [], placeholder: '请选择支付方式', request: { url: '/Account/dataSearchVue/selectAccountType.html', type: 'post', params: { page: 1, size: 5 }, text: '', value: '' } },
        dateType: { submitName: 'dateType', selected: 'A' },
        billDate: { submitName: 'billDate', selected: [] },
        brand: { submitName: 'financialBrand', selected: { value: '2010010101010000000', text: '综合品牌' }, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择品牌', request: { url: 'Account/dataSearch/selectFinanceBrandListForVue.html', type: 'post', params: {page: 1, size: 5, isEnabled: 'Y'}, text: '', value: ''}},
        sort: { submitName: 'sort', selected: { sortField: '', softBy: '' } },
        billNo: { submitName: 'billNo', selected: '', isFilter: false },
      },
      submitFrom: {
        salesman: { submitName: 'salesmanID', selected: {}, valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择业务员', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: ''}},
        remark: { submitName: 'remark', selected: '' },
      },
      sortfilters: [
        { text: '按审核日期排序升序', value: 'A'},
        { text: '按审核日期排序降序', value: 'B'},
        { text: '按录单日期升序', value: 'C'},
        { text: '按录单日期降序', value: 'D'}
      ],
      pickerOptions: pickerOptions,
      queryFormRules: {
        'customer.selected': [
          { required: true, message: '请选择门店', trigger: 'blur' }
        ],
        'subCompanyID.selected': [
          { required: true, message: '请选择所属公司', trigger: 'blur' }
        ],
      },
      submitFromRules: {
        'salesman.selected': [
          { required: true, message: '请选择业务员', trigger: 'blur' }
        ],
      },
      balanceAmtLoading: false,
      balanceAmt: {
        prePayAmt: 0,
        arrearAmt: 0
      },
      tableLoading: false,
      tableData: [],
      dialogTableVisible: false,
      dialogTableLoading: false,
      dialogTableData: [],
      dialogTableSum: {},
      selection: {
        length: 0,
        amt: 0
      },
      billDetailVisible: false
    }
  },
  watch: {
    '$store.state.power' (val) {
      let { isMoreCollection } = val
      console.log(isMoreCollection)
      if (isMoreCollection == 'N') {
        this.queryForm.account.selected = { text: '现金', value: '1001' }
        this.queryForm.account.list.push({ text: '现金', value: '1001' })
      }
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('input').onfocus = function (e) {
          e.currentTarget.select()
        }
        el.querySelector('input').focus()
      }
    }
  },
  computed: {
    queryitem () {
      let tempItem = {}
      Object.values(this.queryForm).forEach(item => {
        if (toRawType(item.selected) == 'Array') {
          if (item.submitName == 'billDate') {
            tempItem['beginDate'] = item.selected[0] || ''
            tempItem['endDate'] = item.selected[1] || ''
            return false
          }
          tempItem[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',') || ''
        } else if (toRawType(item.selected) == 'String') {
          // if (item.submitName == 'financialBrand') {
          //   tempItem[item.submitName + 'ID'] = '2010010101010000000'
          //   tempItem[item.submitName + 'Name'] = '综合品牌'
          //   return false
          // }
          tempItem[item.submitName] = item.selected || ''
        } else if (toRawType(item.selected) == 'Number') {
          tempItem[item.submitName] = item.selected || 0
        } else if (toRawType(item.selected) == 'Object') {
          if (['account', 'financialBrand', 'customer'].includes(item.submitName)) {
            tempItem[item.submitName + 'ID'] = item.selected.value || ''
            tempItem[item.submitName + 'Name'] = item.selected.text || ''
            return false
          }
          if (item.submitName == 'sort') {
            tempItem['sortField'] = item.selected.sortField || ''
            tempItem['softBy'] = item.selected.softBy || ''
            return false
          }
          tempItem[item.submitName] = item.selected.value || ''
        }
      })
      return tempItem
    },
    totalAmt () {
      let num = 0
      this.tableData.forEach((i) => {
        num += Number(i.strikAmt || 0)
      })
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.queryForm.discountAmt.selected = 0
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.queryForm.payableAmt.selected = num
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.queryForm.cashAmt.selected = num
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.queryForm.cardAmt.selected = 0
      return num
    }
  },
  created() {
    if (this.customerID && this.customerName) {
      this.queryForm.customer.list = [ { value: this.customerID, text: this.customerName } ]
      this.queryForm.customer.selected = { value: this.customerID, text: this.customerName }
    }
    if (this.financialBrandID && this.financialBrandName) {
      this.queryForm.brand.list = [ { value: this.financialBrandID, text: this.financialBrandName } ]
      this.queryForm.brand.selected = { value: this.financialBrandID, text: this.financialBrandName }
    }
    this.getBalanceAmt()
    this.$nextTick(() => {
      let body = document.querySelector('body')
      body.className = 'aaa'
    })
  },
  methods: {
    async getBalanceAmt (tag) {
      if (tag == 'customer') {
        this.queryForm.subCompanyID.selected = {}
      } else if (tag == 'brand') {
        this.$nextTick(() => {
          // this.$refs['salesman'].$children[0].focus()
        })
      } else if (tag == 'subCompanyID') {
        this.queryForm.customer.selected = {}
      }
      this.balanceAmtLoading = true
      const { data: res } = await this.$http.post('/Account/salPayVue/queryCustomerBalanceAmt.html', this.Qs.stringify(this.queryitem))
      this.balanceAmtLoading = false
      if (res.code != 'success') return this.$message.error(res.message)
      this.multipleChange()
      let data = JSON.parse(JSON.parse(res.result).data)
      this.balanceAmt = data ? data : { prePayAmt: 0, arrearAmt: 0 }
    },
    multipleChange (tag) {
      if (tag == 'salesman') {
        this.$nextTick(() => {
          // this.$refs['entryUser'].$children[0].focus()
        })
      } else if (tag == 'entryUser') {
        this.$nextTick(() => {
          // this.$refs['remark'].focus()
        })
      }
      this.tableData = []
      this.$refs['calculationFormRef'].resetFields()
      this.$refs['calculationSubmitFormRef'].resetFields()
    },
    async selectDetail () {
      if (this.queryitem.customerID == '' && this.queryitem.subCompanyID == '') return this.$message.warning('请先选择客户或所属公司')
      this.dialogTableVisible = true
      this.dialogTableLoading = true
      let { data, sum } = await this.getDetail()
      this.dialogTableLoading = false
      this.dialogTableData = data
      sum['settledAmt'] = Number(sum.arrearAmt || 0) - Number(sum.billArrearBalance || 0)
      this.dialogTableSum = sum
    },
    async selectDetailAll () {
      if (this.queryitem.customerID == '' && this.queryitem.subCompanyID == '') return this.$message.warning('请先选择客户或所属公司')
      this.tableLoading = true
      let { data } = await this.getDetail()
      this.tableLoading = false
      this.tableData = data
    },
    async getDetail () {
      const { data: res } = await this.$http.post('/Account/salPayVue/selectSalPayList.html', this.Qs.stringify(this.queryitem))
      if (res.code != 'success') return this.$message.error(res.message)
      let { data, sum } = JSON.parse(res.result)
      return { data: data ? JSON.parse(data) : [], sum: sum ? JSON.parse(sum) : {} }
    },
    strikAmtIsShow (row, isShow) {
      this.$set(row, 'strikAmtIsShow', isShow)
    },
    filterMethod ({ billDate }) {
      if (billDate.includes('A')) {
        this.tableData.sort((a, b) => { return Date.parse(b.recordDate) < Date.parse(a.recordDate) ? 1 : -1 })
      } else if (billDate.includes('B')) {
        this.tableData.sort((a, b) => { return Date.parse(a.recordDate) < Date.parse(b.recordDate) ? 1 : -1 })
        console.log(this.tableData.sort((a, b) => { Date.parse(a.recordDate) < Date.parse(b.recordDate) ? 1 : -1 }))
      } else if (billDate.includes('C')) {
        this.tableData.sort((a, b) => { return Date.parse(b.entryDate) < Date.parse(a.entryDate) ? 1 : -1 })
      } else if (billDate.includes('D')) {
        this.tableData.sort((a, b) => { return Date.parse(a.entryDate) < Date.parse(b.entryDate) ? 1 : -1 })
      }
      if (!billDate.length) {
        this.tableData.sort((a, b) => { return Date.parse(b.recordDate) < Date.parse(a.recordDate) ? 1 : -1 })
      }
    },
    dialogFilterMethod ({ billDate }) {
      if (billDate.includes('A')) {
        this.queryForm.sort.selected.sortField = 'recordDate'
        this.queryForm.sort.selected.softBy = 'ASC'
      } else if (billDate.includes('B')) {
        this.queryForm.sort.selected.sortField = 'recordDate'
        this.queryForm.sort.selected.softBy = 'DESC'
      } else if (billDate.includes('C')) {
        this.queryForm.sort.selected.sortField = 'entryDate'
        this.queryForm.sort.selected.softBy = 'ASC'
      } else if (billDate.includes('D')) {
        this.queryForm.sort.selected.sortField = 'entryDate'
        this.queryForm.sort.selected.softBy = 'DESC'
      }
      if (!billDate.length) {
        this.queryForm.sort.selected.sortField = ''
        this.queryForm.sort.selected.softBy = ''
      }
      this.selectDetail()
    },
    tableSummaries (param) {
      const { columns } = param;
      const sums = [];
      let arrearAmt = 0, settlementAmt = 0, billArrearBalance = 0, strikAmt = 0
      this.tableData.forEach(i => {
        arrearAmt += Number(i.arrearAmt || 0)
        settlementAmt += Number(i.arrearAmt || 0) - Number(i.billArrearBalance || 0)
        billArrearBalance += Number(i.billArrearBalance || 0)
        strikAmt += Number(i.strikAmt || 0)
      })
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总价';
          return;
        }
        if (column.property == 'arrearAmt') sums[index] = toFixedRe(arrearAmt, 2)
        if (column.property == 'settlementAmt') sums[index] = toFixedRe(settlementAmt, 2)
        if (column.property == 'billArrearBalance') sums[index] = toFixedRe(billArrearBalance, 2)
        if (column.property == 'strikAmt') sums[index] = toFixedRe(strikAmt, 2)
        
      });
      this.$nextTick(() => {
        this.$refs['table'].doLayout();
      })
      return sums
    },
    numberChange (val, tag) {
      if (tag == 'discountAmt') {
        this.queryForm.payableAmt.selected = Number(this.totalAmt) - val
        this.queryForm.cashAmt.selected = this.queryForm.payableAmt.selected
        this.queryForm.cardAmt.selected = 0
      } else if (tag == 'payableAmt') {
        this.queryForm.discountAmt.selected = Number(this.totalAmt) - val
        this.queryForm.cashAmt.selected = this.queryForm.payableAmt.selected
        this.queryForm.cardAmt.selected = 0
      } else if (tag == 'cashAmt') {
        this.queryForm.cardAmt.selected = Number(this.queryForm.payableAmt.selected) - val
      } else if (tag == 'cardAmt') {
        this.queryForm.cashAmt.selected = Number(this.queryForm.payableAmt.selected) - val
      }
    },
    async onSubmit (command = '') {
      let isMoreCollection = this.$store.state.power.isMoreCollection
      if (!this.tableData.length) return this.$message.error('请选择需要清欠的明细')
      if (isMoreCollection == 'Y') {
        if (this.queryitem.othersPayAmt) {
          if (this.queryitem.accountID == '') {
            return this.$message.error('请选择支付方式')
          }
        }
      } else {
        if (this.queryitem.accountID == '') {
          return this.$message.error('请选择支付方式')
        }
      }
      if (!this.submitFrom.salesman.selected?.value) {
        return this.$message.error('请选择业务员')
      }
      let submitItem = { ...this.queryitem }
      delete submitItem.beginDate
      delete submitItem.endDate
      delete submitItem.recordUserID
      delete submitItem.remark
      delete submitItem.salesmanID
      delete submitItem.softBy
      delete submitItem.sortField
      submitItem['totalAmt'] = this.totalAmt
      submitItem['salesmanID'] = this.submitFrom.salesman.selected.value
      submitItem['salesmanName'] = this.submitFrom.salesman.selected.text
      submitItem['remark'] = this.submitFrom.remark.selected
      let strikePerOrder = [ ...this.tableData ].map(i => {
        i['soureBillNo'] = i.billNo
        i['sourebillType'] = i.billType
        i['isArrearOrPrepay'] = 'Y'
        return i
      })
      
      submitItem['strikePerOrder'] = JSON.stringify(strikePerOrder)
      const loading = this.$loading({
        lock: true,
        text: '提交中,请等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const { data: res } = await this.$http.post('/Account/salPayVue/addAndRecordPayInfo.html', this.Qs.stringify(submitItem))
      loading.close()
      if (res.code != 'success') return this.$message.error(res.message)
      this.$message.success(res.message)
      if (command == 'A') {
        let billNo = JSON.parse(JSON.parse(res.result).data).billNo
        if (this.$store.state.power.customPrint == 'Y') {
          this.mouldPrintBillNo(billNo.replace(/'/g, ''), () => {
            setTimeout(() => {
              top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm#/customerArrearPerOrder`)
            }, 500)
          })
        } else {
          let url = `/Account/salPayVue/Print.html?billNos=${ billNo }`
          window.open(url ,'_blank', "width=1011,height=680,left=300,top=150,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,location=no")
        }
      } else {
        setTimeout(() => {
          top.refreshTabWithUrl(`/templates/vue-account/dist/index.htm#/customerArrearPerOrder`)
        }, 500)
      }
    },
    mouldPrintBillNo(billNo, callback = () => { }) {
      let msgDom = this.$loading({
        lock: true,
        text: '打印启动中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      this.msgDomList = []
      this.msgDomList.push(msgDom)
      printSalOrder({
        billType: g_getValueByKey('SKD'), billNos: [billNo], callback: () => {
          if (this.msgDomList && this.msgDomList.length) {
            this.msgDomList.forEach(item => {
              item.close && item.close()
            })
            this.msgDomList = []
          }
          callback()
        }
      })
    },
    dialogOpen () {
      this.handleSelectionChange(this.tableData)
      this.$nextTick(() => {
        this.tableData.forEach(item => {
          this.$refs.dialogTable.toggleRowSelection(item, true)
        })
      })
    },
    dialogClose () {
      this.dialogTableData = []
      this.selection.length = 0
      this.selection.amt = 0
      this.queryForm.sort.selected.sortField = ''
      this.queryForm.sort.selected.softBy = ''
      this.queryForm.billDate.selected = []
      this.queryForm.salesman.isFilter = false
      this.queryForm.billNo.isFilter = false
      this.queryForm.entryUser.isFilter = false
      this.queryForm.salesman.selected = {}
      this.queryForm.billNo.selected = ''
      this.queryForm.entryUser.selected = {}
    },
    deleteRow ({ $index }) {
      this.tableData.splice($index, 1)
    },
    handleSelectionChange (selection) {
      this.selection.length = selection.length
      let amt = 0
      selection.forEach((i) => {
        amt += Number(i.billArrearBalance)
      })
      this.selection.amt = toFixedRe(amt, 2)
    },
    onSelect () {
      let add = getResultArray('billNo', 'd', this.$refs['dialogTable'].selection, this.tableData)
      let detele = getResultArray('billNo', 'd', this.tableData, this.$refs['dialogTable'].selection)
      if (detele.length) {
        detele.forEach(i => {
          this.tableData = this.tableData.filter(j => i.billNo != j.billNo)
        })
      }
      if (add.length) {
        this.tableData = this.tableData.concat(add)
      }
      this.dialogTableVisible = false
    },
    dialogTableSummaries (param) {
      const { columns } = param
      const sums = [];
      for (let key in this.dialogTableSum) {
        columns.forEach((column, index) => {
          if (index == 0) {
            sums[index] = '合计'
            return
          }
          if (column.property == key) {
            sums[index] = this.dialogTableSum[key]
            return
          }
        })
      }
      this.$nextTick(() => {
        this.$refs['dialogTable'].doLayout();
      })
      return sums
    },
    popoverShow (popper) {
      const popover = this.$refs['popover_' + popper]
      popover.$nextTick(() => {
        let input = popover.$refs['popper'].querySelectorAll('input')
        input[input.length - 1].focus()
      })
    },
    tableFilter (popper, tag) {
      this.$refs['popover_' + popper].doClose()
      this.selectDetail()
      let item = this.queryForm[tag]
      if (toRawType(item.selected) == 'String') {
        item.isFilter = item.selected ? true : false
      } else if (toRawType(item.selected) == 'Object') {
        item.isFilter = item.selected.value ? true : false
      }
    },
    billNoInputClear () {
      const popover = this.$refs['popover_billNo']
      popover.$nextTick(() => {
        popover.$refs['popper'].querySelector('input').value = ''
      })
    },
    billDetailOpen(row) {
      // if (row.billType == 'TZD' || row.billType == 'FYD' || row.billType == 'QC' || row.billType == 'SKD') return false
      if (['TZD', 'FYD', 'QC', 'SKD', 'FHD', 'FOD'].includes(row.billType)) return false
      this.billDetailVisible = true
      this.$nextTick(() => {
        let billDetailDialog = this.$refs['billDetailDialog']
        // 获取单据详情事件
        billDetailDialog.getDetailInfo({ billNo: row.billNo, billType: row.billType })
      })
    },
    billDetailClose() {
      this.billDetailVisible = false
      this.$nextTick(() => {
        let billDetailDialog = this.$refs['billDetailDialog']
        // 获取单据详情事件
        billDetailDialog.drawerClose()
      })
    },
    printTable() {
      let billNo = this.$refs['dialogTable'].selection.map(i => "'" + i.billNo + "'").join(',')
      if (!billNo) return this.$message.error('请至少有一个单据')
      let params = {
        billNo: billNo,
        beginSearchDate: this.queryitem.beginDate,
        endSearchDate: this.queryitem.endDate,
      }
      console.log(`/Account/salPayVue/PrintNew.html?${this.Qs.stringify(params)}`)
      window.open(`/Account/salPayVue/PrintNew.html?${this.Qs.stringify(params)}`,'_blank', "width=1011,height=680,left=300,top=150,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,location=no")
    }
  }
};
</script>
<style lang="less">
.payType {
  .el-input__inner {
    padding: 0 !important;
  }
}
.soft_Table_popover {
  padding: 0;
  .el-table-filter {
    margin: 0;
  }
}
.aaa{
  .el-table-filter__list {
    .el-table-filter__list-item:nth-child(1) {
      display: none;
    }
  }
}
.query_btn_group {
  display: flex;
  &:not(:nth-child(1)) {
    margin-top: 12px;
  }
  .billNo_input {
    &:hover .el-input__suffix {
      display: block;
    }
    .el-input__suffix {
      display: none;
    }
  }
  .el-button {
    margin-left: 6px;
    color: #606266;
    &:hover {
      color: #409EFF;
    }
  }
}
.reference {
  cursor: pointer;
  &.highlight label {
    color: #409EFF;
  }
}
</style>
<style scoped lang="less">
#tab {
  height: calc(100vh - 20px);
  .box-card {
    display: flex;
    flex-flow: column;
    height: calc(100% - 2px);
    ::v-deep .el-card__header {
      padding: 8px 20px;
      height: 33px;
      background-color: #F5F7FA;
      color: #409EFF;
    }
    ::v-deep .el-card__body {
      padding: 6px;
      flex: 1;
      box-sizing: border-box;
    }
  }
  .el-aside {
    ::v-deep .el-card__body {
      .el-form {
        height: 100%;
        .el-scrollbar {
          height: 100%;
        }
        .el-form-item {
          margin: 18px 0 0;
          position: relative;
          .el-form-item__label {
            position: absolute;
            z-index: 2;
            top: -12px;
            margin-left: 10px;
            padding: 0 6px;
            line-height: normal;
            background-color: #fff;
          }
          .amt-info {
            border: 1px #F56C6C solid;
            color: #F56C6C;
            span {
              display: block;
              text-align: center;
            }
          }
        }
      }
      .calculation-form {
        .el-form-item {
          text-align: center;
          .el-form-item__label {
            margin: 0;
            left: 36px;
          }
          .input-with-select {
            .el-input-group__prepend {
              padding: 0 12px;
              background-color: #fff;
              .select-multiple {
                display: inline-block;
                width: 50px;
              }
            }
          }
          .el-input-number .el-input__inner {
            text-align: left;
          }
        }
      }
    }
    .is-collapse {
      width: calc(100% - 2px);
      height: calc(100% - 2px);
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      border: 1px #DCDFE6 solid;
      cursor: pointer;
      background-color: rgba(83, 168, 255, 0.1);
      color: #409EFF;
    }
    .select_multiple {
      ::v-deep .el-select__tags {
        max-height: 80px;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
  }
  .el-main {
    padding: 0 6px 0;
    .box-card {
      & > ::v-deep .el-card__body {
        // display: flex;
        // flex: 1;
        // flex-flow: column;
        height: 100%;
        // height: calc(100% - 33px);
        box-sizing: border-box;
        .box-card-query {
          height: 46px;
          flex-shrink: 0;
          .el-form {
            .el-form-item {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
  .table {
    // height: calc(100% - 48px);
    height: calc(100% - 1.5px);
    ::v-deep .el-table {
      th, td {
        padding: 0;
        .cell {
          font-size: 14px;
          padding: 0;
        }
      }
    }
  }
  ::v-deep .el-dialog {
    height: 86vh;
    min-width: 1000px;
    .el-dialog__body {
      height: calc(100% - 54px);
      padding-top: 0;
      box-sizing: border-box;
      display: flex;
      flex-flow: column;
      .table {
        height: calc(100% - 48px);
      }
      .box-card-query {
        .el-card__body {
          padding: 6px;
        }
        .el-form {
          .el-form-item {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .border {
    border-top: 1px #E4E7ED solid;
  }
  .cell-p {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.bill-detail-dialog {
  ::v-deep .el-dialog__header {
    padding: 0;
  }

  ::v-deep .el-dialog__body {
    padding: 20px;
    height: 500px;
  }

  ::v-deep .el-dialog {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
